import * as React from 'react';
import { Form, Nav } from 'react-bootstrap';
import styled from 'styled-components';

export const Wrapper = styled.div`
    .ag-theme-bootstrap {
        font-family: Roboto !important;
    }

    .ag-theme-bootstrap .ag-icon {
        color: white;
    }

    border-style: solid;
    border-color: #ddd;
    border-width: 1px 1px 1px 1px;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    padding: 10px;
`;

export const GridWrapper = styled.div`
    height: 73vh;
    width: 100%;
    
    .ag-header-viewport {
        background-color: black;
    }

    .ag-header-cell {
        color: white;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        padding-bottom: 5px;
    }

    .ag-header-cell > .ag-cell-label-container > .ag-header-cell-label {
        display: flex;
        justify-content: center;
    }

    .ag-header-cell > .ag-react-container {
        display: flex;
        justify-content: center;
        align-items: flex-end;
    }

    .ag-header-cell > .ag-react-container > div {
        text-align: center;
    }

    .ag-body-viewport {
        border-left: 1px solid #ccc;
        border-right: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
    }

    .ag-cell {
        text-align: center;
        // line-height: 40px;
        display: flex;
        justify-content: center;
    }

    .no-wrap {
        overflow: hidden;
    }

    @media screen and (max-width: 1920px) {
        .ag-header {
            font-size: 12px;
        }
        
        .ag-cell {
            font-size: 12px;
        }
    }
`;

interface INavWrapperProps {
    verticalAlign?: string,
    minTabWidth?: string
}

export const ViewWrapper = styled.div`
    padding-left: 2px;
    padding-right: 2px;

    .modal-container {
        position: relative;
    }

    .modal-container .modal, .modal-container .modal-backdrop {
        position: absolute;
    }
`;


export const NavWrapper = styled(Nav) <INavWrapperProps>`
    & > li {
        height: 42px;
        margin-bottom: -2px;
    }

    & > li > a {
        font-size: 14px;
        font-weight: 500;
        background-color: #ddd;
        color: #a1a1a1;
        // width: 160px;
        text-align: center;
        // line-height: 15px;
        padding: 5px 15px;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: ${(p: INavWrapperProps) => p.verticalAlign ? p.verticalAlign : 'flex-end'};
        min-width: ${(p: INavWrapperProps) => p.minTabWidth ? p.minTabWidth + 'px !important' : '0px'};
    }

    & > li > a:hover {
        background-color: #a0c5e5;
        color: black;
    }

    & > li > a.action {
        background-color: white;
        color: black;
    }

    & > li.active > a {
        // font-size: 14px;
        // line-height: 15px;
        // padding: 5px 7.5px;
    }

    @media (max-width: 1823px) {
        & > li > a,
        & > li.active > a {
            // font-size: 12px;
            min-width: 120px;
        }
    }
`;

export const FormWrapper = styled(Form)`
    & > div.form-group {
        margin-bottom: 5px;
    }

    & > div.form-group > .col-lg-4 {
        padding-left: 5px;
        padding-right: 5px;
    }

    & > div.form-group > .col-lg-8,
    & > div.row > .col-lg-8 {
        padding-left: 5px;
    }

    & > div.form-group > .control-label {
        padding-top: 1px;
    }

    & > div.form-group > .form-control-static {
        padding-top: 1px;
        padding-bottom: 1px;
        min-height: initial;
    }
`;

export const ImageWrapper = styled.div`
    border: 1px solid #ccc;
    padding: 8px;
    border-radius: 4px;
    margin-bottom: 20px;
    margin-left: 0px;
    margin-right: 0px;
    background-color: white;

    .image-div {
        // display: flex;
        // justify-content: center;
        margin-bottom: 20px;
        border: 1px solid #ddd;
        padding: 5px;
        margin: 2px;
        border-radius: 4px;
        width: 24.6%;
    }

    .image-spacer {
        height: 23px;
    }

    @media screen and (max-width: 500px) {
        .image-div {
            width: 100%;
        }

        .image-spacer {
            height: 5px;
        }
    }

    .image-div:nth-child(3) {
        border-right-width: 1px;
    }

    .microsite-image {
        display: flex;
        justify-content: center;
    }

    .microsite-image > img {
        border: 4px solid #FFF;
        //display: inline-block;
        //height: 215px;
        max-height: 190px;
        margin: 8px 8px 0px 8px;
        //overflow: hidden;
        //position: relative;
        //width: 215px;
        max-width: 200px;
    }

    .microsite-caption {
        //display: flex;
        //justify-content: center;
        border: 4px solid #FFF;
        margin: 0px 8px 0px 8px;   
    }
`;

export const todoStyles: { [key: string]: React.CSSProperties } = {
    wrapper: {
        marginTop: 20,
        marginBottom: 20
    },
    panel: {
        border: '1px solid #aaa',
        backgroundColor: 'white'
    },
    header: {
        display: 'inline-block',
        backgroundColor: 'black',
        color: 'white',
        padding: '5px 14px',
        cursor: 'pointer',
        fontWeight: 600,
        fontSize: 13,
        letterSpacing: 0.5,
        textTransform: 'uppercase' as 'uppercase'
    },
    body: {
        padding: '8px 16px 12px'
    },
    row: {
        display: 'flex',
        alignItems: 'center',
        padding: '10px 0',
        cursor: 'pointer',
        textDecoration: 'none',
        color: '#222',
        fontSize: 15
    },
    badge: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'red',
        color: 'white',
        borderRadius: '50%',
        width: 32,
        height: 32,
        fontWeight: 700,
        fontSize: 14,
        marginRight: 12,
        flexShrink: 0
    }
};

export const notificationStyles: { [key: string]: React.CSSProperties } = {
    wrapper: {
        marginTop: 20,
        marginBottom: 20
    },
    panel: {
        border: '1px solid #aaa',
        backgroundColor: 'white'
    },
    header: {
        display: 'inline-block',
        backgroundColor: 'black',
        color: 'white',
        padding: '5px 14px',
        cursor: 'pointer',
        fontWeight: 600,
        fontSize: 13,
        letterSpacing: 0.5,
        textTransform: 'uppercase' as 'uppercase'
    },
    table: {
        width: '100%',
        borderCollapse: 'collapse' as 'collapse'
    },
    th: {
        textAlign: 'left' as 'left',
        padding: '8px 12px',
        fontSize: 12,
        fontWeight: 600,
        color: '#555',
        borderBottom: '1px solid #eee'
    },
    td: {
        padding: '10px 12px',
        fontSize: 14,
        borderBottom: '1px solid #f5f5f5',
        verticalAlign: 'top' as 'top'
    },
    dateCell: {
        whiteSpace: 'nowrap' as 'nowrap',
        color: '#555',
        fontSize: 13
    },
    tdDate: {
        padding: '10px 12px',
        fontSize: 13,
        borderBottom: '1px solid #f5f5f5',
        verticalAlign: 'top' as 'top',
        whiteSpace: 'nowrap' as 'nowrap',
        color: '#555'
    },
    messageCell: {
        color: '#333'
    },
    tdMessage: {
        padding: '10px 12px',
        fontSize: 14,
        borderBottom: '1px solid #f5f5f5',
        verticalAlign: 'top' as 'top',
        color: '#333'
    },
    replyBtn: {
        backgroundColor: '#3b7bbf',
        color: 'white',
        border: 'none',
        padding: '4px 14px',
        borderRadius: 3,
        cursor: 'pointer',
        fontSize: 13,
        textDecoration: 'none',
        display: 'inline-block',
        whiteSpace: 'nowrap' as 'nowrap'
    },
    empty: {
        padding: '16px 12px',
        color: '#888',
        fontSize: 13
    },
    pagination: {
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        padding: '8px 12px',
        borderTop: '1px solid #eee'
    },
    pageBtn: {
        background: 'none',
        border: '1px solid #ccc',
        borderRadius: 3,
        padding: '3px 10px',
        cursor: 'pointer',
        fontSize: 13
    },
    pageInfo: {
        fontSize: 13,
        color: '#555'
    }
};

export const gridStyles: { [key: string]: React.CSSProperties } = {
    cellSmallText: {
        fontSize: 12
    },
    paginationRow: {
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        marginTop: 8,
        padding: '8px 0',
        position: 'sticky',
        bottom: 0,
        zIndex: 2,
        backgroundColor: '#fff'
    }
};

export const coachPickerStyles: { [key: string]: React.CSSProperties } = {
    select: {
        width: 250,
        marginBottom: 10
    }
};

export const filterBarStyles: { [key: string]: React.CSSProperties } = {
    well: {
        marginBottom: 5
    },
    row: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center'
    },
    controlWrapper: {
        marginRight: 20,
        marginBottom: 5
    },
    controlLabel: {
        marginRight: 5
    },
    searchInput: {
        width: 250
    },
    buttonRow: {
        marginTop: 15
    },
    showHiddenButton: {
        marginRight: 10
    }
};

export const drawerStyles: { [key: string]: React.CSSProperties } = {
    container: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column'
    },
    scrollBody: {
        padding: '5px 10px',
        overflowY: 'auto',
        flex: 1
    },
    titleRow: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 5
    },
    title: {
        margin: 0
    },
    closeButton: {
        border: '0 none'
    },
    fullWidth: {
        width: '100%'
    }
};

export const ContentWrapper = styled.div`
    .modal-backdrop {
        z-index: 99999 !important;
    }

    .badge.pending {
        background-color:red;
    }
    

    .modal {
        z-index: 99999 !important;
    }
`;